<!--  -->
<template>
  <div>

    <!-- title -->
    <div class="title">
      <div style="margin: 0.8em 0 0.8em  0;">
        <h3>Quét mã để chuyển tiền</h3>
      </div>
    </div>

    <!-- orderID -->
    <OrderIdComp :order-info="orderInfo" />

    <!-- time left -->
    <TimerComp2 :order-info="orderInfo" :pay-time-info="payTimeInfo" />

    <!-- copy -->
    <div class="pannel" v-if="orderInfo.orderId">
      <div class="infoContainer">
        <div class="items1">Ngân hàng:</div>
        <div class="items2">
          <span v-if="copyBankIf" style="color: green;"><b>{{orderInfo.recBank}}</b></span>
          <span v-else style="color: blue;"><b>{{orderInfo.recBank}}</b></span>
        </div>
        <div class="items3">
          <button v-on:click="copyBank" class="btn copy">chép</button>
        </div>
      </div>
      <div class="infoContainer">
        <div class="items1">Tên:</div>
        <div class="items2">
          <span v-if="copyOwnerIf" style="color: green;"><b>{{orderInfo.recOwner}}</b></span>
          <span v-else style="color: blue;"><b>{{orderInfo.recOwner}}</b></span>
        </div>
        <div class="items3">
          <button v-on:click="copyOwner" class="btn copy">chép</button>
        </div>
      </div>
      <div class="infoContainer">
        <div class="items1">Tài khoản nhận:</div>
        <div class="items2">
          <span v-if="copyAccountIf" style="color: green;"><b>{{orderInfo.recAccount}}</b></span>
          <span v-else style="color: blue;"><b>{{orderInfo.recAccount}}</b></span>
        </div>
        <div class="items3">
          <button v-on:click="copyAccount" class="btn copy">chép</button>
        </div>
      </div>
      <div class="infoContainer">
        <div class="items1">Số tiền chuyển:</div>
        <div class="items2">
          <span v-if="copyAmountIf" style="color: green;"><b>{{orderInfo.amount}}</b></span>
          <span v-else style="color: red;"><b>{{orderInfo.amount}}</b></span>
        </div>
        <div class="items3">
          <button @click="copyAmount" class="btn copy">chép</button>
        </div>
      </div>
      <div class="infoContainer">
        <div class="items1">Nội dung ghi:</div>
        <div class="items2">
          <span v-if="copyTranMarkIf" style="color: green;"><b>{{orderInfo.tranMark}}</b></span>
          <span v-else style="color: red;"><b>{{orderInfo.tranMark}}</b></span>
        </div>
        <div class="items3">
          <button @click="copyTranMark" class="btn copy">chép</button>
        </div>
      </div>
    </div>

    <!-- time tips -->
    <TimeTipsComp :order-info="orderInfo" />

    <!-- other pay -->
    <div class="pannel" v-if="recQrUrlImg">
      <div class="pay-flow">
        <p style="color: #4CAF50;"><b>Bạn cũng có thể thử quét QrCode</b></p>
      </div>
      <table>
        <tr>
          <td style="width: 50%;">
            <div>
              <img :src="recQrUrlImg" style="margin: 0 auto;width: 80%;" />
              <img src="/imgs/bc/logo2.png" style="margin: 0 auto;width: 80%;" />
            </div>
          </td>
          <td style="width: 50%;">
            <div class="pay-flow" style="font-size: 0.8em;">
              <p class="no">1. Tải xuống và lưu hình ảnh mã T và mã QR</p>
              <p class="no">2. Sử dụng ứng dụng để quét mã QR và thanh toán</p>
            </div>
            <div class="pannel-btn">
              <a class="btn down" :href="recQrUrlImg" :download="`${orderInfo.orderId}-${orderInfo.amount}.png`" style="padding:0.4em;">Tải về</a>
            </div>
          </td>
        </tr>
      </table>
      <!-- -->
      <div class="pannel pannel-btn">
        <div style="padding-bottom:0.5em;">
        </div>
      </div>
    </div>

    <!-- Notice -->
    <div class="pannel-simp attention">
      <p class=""><b>Lưu ý:&nbsp;</b><span style="color: red;">Vui lòng không thanh toán quá thời hạn</span></p>
      <p class=""><b>Lưu ý:&nbsp;</b><span style="color: red;">Vui lòng không sửa đổi số tiền </span></p>
      <p class=""><b>Lưu ý:&nbsp;</b><span style="color: red;">Vui lòng nhập thông tin chính xác khi chuyển tiền</span></p>
      <p class=""><b>Lưu ý:&nbsp;</b>Thời gian xác nhận thanh toán thành công là từ 5 đến 10 phút. <span style="color: red;">Sau khi thanh toán, trong vòng 10 phút mà chưa nhận được thanh toán, xin vui lòng liên hệ bộ phận chăm sóc khách hàng để kiểm tra về đơn hàng</span></p>
    </div>

  </div>
</template>

<script>
//
import OrderIdComp from "@/views/comp/slot_order_id_comp";
import TimerComp2 from "@/views/comp/slot_timer_comp2";
import TimeTipsComp from "@/views/comp/slot_time_tips_comp";
//
import QRCode from "qrcode";
//
export default {
  components: {
    OrderIdComp,
    TimerComp2,
    TimeTipsComp,
  },
  props: {
    orderInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    payTimeInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      // 复制相关
      copyBankIf: false,
      copyOwnerIf: false,
      copyAccountIf: false,
      copyAmountIf: false,
      copyTranMarkIf: false,
      //
      recQrUrlImg: "",
      utr: "",
    };
  },
  computed: {},
  created() {},
  methods: {
    //
    init() {
      console.log(this.orderInfo);
      this.rcode = this.orderInfo.tranMark;
      // 生成二维码;
      if (this.orderInfo.recQrUrl) {
        QRCode.toDataURL(
          this.orderInfo.recQrUrl,
          { errorCorrectionLevel: "L", margin: 1, width: 500 },
          (err, url) => {
            if (err) {
              return;
            }
            this.recQrUrlImg = url;
          }
        );
      }
    },
    // 复制银行
    copyBank: function () {
      this.$parent.$parent.copySome(
        this.orderInfo.recBank,
        1,
        () => {
          this.copyBankIf = true;
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    // 复制
    copyOwner: function () {
      this.$parent.$parent.copySome(
        this.orderInfo.recOwner,
        1,
        () => {
          this.copyOwnerIf = true;
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    // 复制
    copyAccount: function () {
      this.$parent.$parent.copySome(
        this.orderInfo.recAccount,
        1,
        () => {
          this.copyAccountIf = true;
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    // 复制金额
    copyAmount: function () {
      this.$parent.$parent.copySome(
        this.orderInfo.amount,
        2,
        () => {
          this.copyAmountIf = true;
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    // 复制
    copyTranMark: function () {
      this.$parent.$parent.copySome(
        this.orderInfo.tranMark,
        2,
        () => {
          this.copyTranMarkIf = true;
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    //
  },
};
</script>

<style>
</style>

<style lang="scss" scoped>
</style>
